import { Fold, Lens, Traversal } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { optional, record, string, } from "@discovery/prelude/lib/data/validated";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Link from "@discovery/sonic-api-ng/lib/api/cms/links";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Video2DefaultImageAttributes, _Video2Route, _Show2Route, _Show2Packages, _Show2PosterImageAttributes, _Show2DefaultImageAttributes, _VideosCollection, _ShowsCollection, } from "../optics";
const _ColItem2Videos = Fold.compose(Optics._ColItem2Video, Fold.liftM((attributes, desktopBannerImg, mWebBannerImg, route) => ({
    name: attributes.name,
    descriptionM: attributes.description,
    minimumAgeM: attributes.minimumAge,
    desktopBannerImg,
    mWebBannerImg,
    route,
    packages: "",
}), Optics._Video2Attributes, _Video2DefaultImageAttributes, Fold.compose(Optics._Video2Images, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "poster"), Res._Response(), Lens.prop("attributes")), _Video2Route));
const _ColItem2Links = Fold.compose(Optics._ColItem2Link, Fold.liftM((name, desktopBannerImg, mWebBannerImg, route) => ({
    name,
    desktopBannerImg,
    mWebBannerImg,
    packages: "",
    route,
}), Fold.compose(Res._Response(), Lens.path("attributes", "title"), M._Just()), Fold.compose(Res._Rel("images"), Optics._ImagesOfKind("default"), Res._Response(), Lens.prop("attributes")), Fold.compose(Res._Rel("images"), Optics._ImagesOfKind("alternate"), Res._Response(), Lens.prop("attributes")), Fold.compose(Res._Rel("linkedContentRoutes"), Res._ForEach(), Res._Response(), Lens.path("attributes", "url"))));
const _ColItem2Shows = Fold.compose(Optics._ColItem2Show, Fold.liftM((attributes, desktopBannerImg, mWebBannerImg, route, packages) => ({
    name: attributes.name,
    packagesM: M.of([]),
    descriptionM: attributes.description,
    minimumAgeM: attributes.minimumAge,
    hasNewEpisodes: attributes.hasNewEpisodes,
    desktopBannerImg,
    mWebBannerImg,
    route,
    packages: M.fromMaybe(packages, ""),
    type: "show",
}), Optics._Show2Attributes, _Show2DefaultImageAttributes, _Show2PosterImageAttributes, _Show2Route, Fold.pre(_Show2Packages)));
const customAttrValidator = optional(record({
    tag1: string,
    tag2: string,
}));
export const _MastheadItems = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Fold.liftM((ctaLabelM, customAttr, imageInfo) => (Object.assign({ ctaLabelM,
    customAttr }, imageInfo)), Fold.compose(Res._Response(), Lens.path("attributes", "title")), Fold.pre(Fold.compose(Fold.pre(Optics._GetCustomAttributesForComponent(customAttrValidator)), M._Just(), M._Just())), Fold.compose(Optics._Col2Items, Fold.alt(_ColItem2Shows, _ColItem2Links, _ColItem2Videos))));
const _CampaignLandingPageShow = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, _ShowsCollection);
const _CampaignLandingPageVideo = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, _VideosCollection);
export const _CampaignLandingPage = Fold.alt(_CampaignLandingPageShow, _CampaignLandingPageVideo);
export const _Taxonomy = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Optics._Col2Items, Res._Rel("taxonomyNode"), Fold.liftM((name, mobileImg, urlM, desktopImg) => ({
    name,
    mobileImg,
    urlM,
    desktopImg,
}), Fold.compose(Res._Response(), Lens.path("attributes", "name"), M._Just()), Fold.compose(Res._Rel("images"), Optics._ImagesOfKind("default"), Res._Response(), Lens.prop("attributes")), Fold.pre(Fold.compose(Res._Rel("routes"), Res._Response(), Fold._each(), Lens.path("attributes", "url"))), Fold.compose(Res._Rel("images"), Optics._ImagesOfKind("logo"), Res._Response(), Lens.prop("attributes"))));
export const VideoRail = Fold.compose(Optics._CollectionGetter, _VideosCollection);
export const BannerId = Fold.compose(Optics._CollectionResponseGetter, Optics._Response2ResponseData(), Optics._CollectionGetter, Optics._Col2CustomAttributes);
const bannerAD = { fallbackAd: Link.Resource.target };
export const BackupAd = Fold.compose(Optics._CollectionResponseGetter, Optics._Response2ResponseData(), Optics._CollectionGetter, Fold.mapF(Res.addNewRelationships(bannerAD)), Res._Rel("fallbackAd"), Fold.liftM((image, url) => ({
    image,
    url,
}), Fold.compose(Res._Rel("images"), Optics._ImagesOfKind("thumbnail"), Res._Response(), Lens.prop("attributes")), Fold.compose(Res._Rel("linkedContentRoutes"), Res._ForEach(), Optics._Route2AttributesFiltered({ canonical: true }), Lens.prop("url"))));
export const VideoRailsforPoster = Fold.compose(Optics._CollectionGetter, _VideosCollection);
const ShowRailsforPoster = Fold.compose(Optics._CollectionGetter, _ShowsCollection);
export const Description = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Res._Response(), Lens.path("attributes", "description"), M._Just());
const _LiveTv = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Optics._Col2Items);
export const _LiveTvVideoGenre = Fold.compose(_LiveTv, Res._Rel("video"), Res._Rel("txGenres"), Res._ForEach(), Res._Response(), Lens.path("attributes", "name"), M._Just());
export const _LiveTvChannelGenre = Fold.compose(_LiveTv, Optics._ColItem2Channel, Res._Rel("txGenres"), Res._ForEach(), Res._Response(), Lens.path("attributes", "name"), M._Just());
export const Genre = Fold.alt(_LiveTvVideoGenre, _LiveTvChannelGenre);
export const _PosterData = Fold.alt(ShowRailsforPoster, VideoRailsforPoster);
export const _LiveChannel = Fold.compose(_LiveTv, Optics._ColItem2Channel, Fold.liftM((name, id, packages) => ({
    name,
    streamIdM: M.of({
        id: id,
        type: "CHANNEL",
        instigator: "MANUAL",
    }),
    packagesM: M.of(packages),
}), Fold.compose(Res._Response(), Lens.path("attributes", "name")), Fold.compose(Res._Response(), Lens.prop("id")), Fold.compose(Res._Response(), Lens.path("attributes", "packages"))));
export const _LiveVideo = Fold.compose(_LiveTv, Res._Rel("video"), Fold.liftM((name, id, packages) => ({
    name,
    streamIdM: M.of({
        id: id,
        type: "VIDEO",
        instigator: "MANUAL",
    }),
    packagesM: packages,
}), Fold.compose(Res._Response(), Lens.path("attributes", "name")), Fold.compose(Res._Response(), Lens.prop("id")), Fold.compose(Res._Response(), Lens.path("attributes", "packages"))));
export const _LiveTvVideo = Fold.alt(_LiveVideo, _LiveChannel);
export const _RailsData = Fold.compose(Optics._RouteResponse2Route, Optics._Route2Page, Optics._Page2Items, Optics._PageItem2Collection, Optics._CollectionGetter);
export const _RailTitle = Fold.compose(Optics._CollectionGetter, Optics._ColAttributes2Title);
export const _CollectionAlias = Fold.compose(Optics._CollectionGetter, Optics._ColAttributes2Alias);
export const _TemplateId = Fold.compose(Optics._CollectionGetter, Optics._Col2TemplateId);
export const RailTemp = Fold.compose(Optics._CollectionGetter, Optics._Col2TemplateId);
export const HeroVideoRail = Fold.compose(Optics._CollectionGetter, _VideosCollection);
const HeroShowRails = Fold.compose(Optics._CollectionGetter, _ShowsCollection);
export const _HeroRailData = Fold.alt(HeroVideoRail, HeroShowRails);
export const HeroSuperStarRails = Fold.compose(Optics._CollectionGetter, Optics._Col2Items, Optics._ColItem2TaxonomyNode, Fold.liftM((attributes, image, route) => ({
    name: M.fromMaybe(attributes.name, ""),
    packages: "",
    packagesM: M.of([""]),
    id: "",
    videoType: M.of(""),
    image: image,
    route: route,
}), Optics._TxNode2Attributes, Fold.compose(Optics._TxNode2Images, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "default"), Res._Response(), Lens.prop("attributes")), Fold.compose(Optics._TxNode2Routes, Optics._Route2AttributesFiltered({ canonical: true }), Lens.prop("url"))));
export const _GridId = Fold.compose(Optics._CollectionGetter, Optics._Col2Id);

